import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { getContextSuggestions } from './suggestions';

/**
 * Empty-state view shown when the chat has no messages yet.
 * Offers context-aware suggestions and category shortcuts.
 */
const CopilotWelcome = ({ context, onSend }) => {
  const suggestions = getContextSuggestions(context);

  const topicButtons = [
    { label: 'ECO Workflow', prompt: 'How do I create and manage ECOs?' },
    { label: 'Parts & BOMs', prompt: 'How do I manage parts and BOMs?' },
    { label: 'Compliance', prompt: 'Tell me about compliance requirements' },
    { label: 'Integrations', prompt: 'What integrations are available?' },
    { label: 'Quality & Audits', prompt: 'Show me quality and audit features' },
    { label: 'Reports', prompt: 'Help me with reports and metrics' },
  ];

  return (
    <div className="text-center py-4">
      <div className="w-14 h-14 mx-auto mb-3 bg-gradient-to-br from-cyan-500/20 to-purple-600/20 rounded-2xl flex items-center justify-center">
        <Sparkles className="w-7 h-7 text-cyan-400" />
      </div>
      <h4 className="text-white font-bold mb-1">Welcome to Baselinx Copilot</h4>
      <p className="text-gray-400 text-sm mb-4">
        I can help you navigate the PLM system, find information, and answer questions.
      </p>

      <div className="space-y-2 mb-4">
        <p className="text-xs text-gray-500 uppercase tracking-wide">Suggested for you</p>
        {suggestions.map((s, idx) => (
          <button
            key={s?.text ?? `suggestion-${idx}`}
            data-testid={`copilot-suggestion-${idx}`}
            onClick={() => onSend(s.text)}
            className="w-full flex items-center gap-3 p-2.5 bg-slate-800/50 border border-slate-700 rounded-lg hover:bg-slate-800 hover:border-cyan-500/50 transition text-left group"
          >
            <s.icon className="w-4 h-4 text-cyan-400" />
            <span className="text-gray-300 text-sm group-hover:text-white">{s.text}</span>
            <ArrowRight className="w-4 h-4 text-gray-500 ml-auto group-hover:text-cyan-400" />
          </button>
        ))}
      </div>

      <div className="border-t border-slate-700 pt-4">
        <p className="text-xs text-gray-500 uppercase tracking-wide mb-3">Browse by topic</p>
        <div className="grid grid-cols-2 gap-2">
          {topicButtons.map((t) => (
            <button
              key={t.label}
              data-testid={`copilot-topic-${t.label.replace(/\s+/g, '-').toLowerCase()}`}
              onClick={() => onSend(t.prompt)}
              className="p-2 bg-slate-800/30 border border-slate-700 rounded-lg hover:bg-slate-800 hover:border-cyan-500/30 transition text-left"
            >
              <span className="text-cyan-400 text-xs font-mono">{t.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CopilotWelcome;
